<template>
    <div class="corpinfo-edit">
        <v-page-header :back="{
                title: '企业资料',
                goBack: goBack,
            }"
            title="编辑注册企业信息"
        />
        <v-page-header title="注册企业信息" level="section" />
        <div v-if="corpAdmin.need_verify" class="verify-status">
            <v-status-bar v-if="info.status == 2" kind="error">
                <reviewFailed :error="info.error" @resetInfo="resetInfo" />
            </v-status-bar>
            <v-status-bar v-if="info.status == 1" kind="wait">
                <span>以下信息正在审核中，预计1到2个工作日可审核完毕，请耐心等待</span>
            </v-status-bar>
        </div>
        <div class="corpinfo-edit-conetnt">
            <v-form ref="form" kind="desc" :class="{'edit-disabled': info.status == 1 && corpAdmin.need_verify}" size="small" @submit="submit">
                <v-form-item label="企业头像" name="avatar" class="form-avatar">
                    <span class="avatar">
                        <img :src="info.eLogo || logo" class="avatar-view">
                        <change-avatar-dialog class="avatar-select" @avatarChange="avatarChange" />
                    </span>
                    <div class="tips">
                        支持jpg/jpeg/png，尺寸200X200px，小于2M
                        <br>
                        可用于电话接待页面、员工对外形象的默认头像。应与企业经营相关，且企业需拥有法律认可使用权限，建议使用企业商标、品牌LOGO等。如使用法人或明星肖像，需提供相关证明或授权。
                    </div>
                </v-form-item>
                <div class="form-item-list">
                    <v-form-item label="企业全称" required="请输入企业全称" name="eFullName">
                        <v-input v-model.trim="info.eFullName" placeholder="请输入" disabled :clearable="false" :length-calculator="externalNameCalc" />
                    </v-form-item>
                    <v-form-item label="企业简介" name="eDesc">
                        <v-textarea v-model.trim="info.eDesc" placeholder="请输入" limit="480" :length-calculator="externalNameCalc" autoheight class="text-area" />
                        <div class="tips">
                            应与企业《营业执照》经营范围相关，建议描述产品及服务相关内容，不得存在违法违禁信息。
                        </div>
                    </v-form-item>
                    <v-form-item label="企业简称" required="请输入企业简称" name="eName">
                        <v-input v-model.trim="info.eName" placeholder="请输入" limit="12" :length-calculator="externalNameCalc" />
                        <div class="tips">
                            需与企业提交资质合理相关，添加与全称无关的关键字可能导致审核失败
                        </div>
                    </v-form-item>
                    <v-form-item label="企业主页" name="eHome" :rules="rules.eHome">
                        <v-input v-model.trim="info.eHome" placeholder="请输入" :limit="48" />
                        <div class="tips">
                            请填写完整主页地址，一般以http://或https://等网络协议开头；网站不得存在违法违禁信息。
                            <br>
                            网站ICP备案与企业资质保持一致（如为第三方网站，则需提供合作或授权证明）
                        </div>
                    </v-form-item>
                    <v-form-item label="所属行业" required="请选择所属行业" name="eIndustry" :rules="rules.industry">
                        <selectIndustry :industrylist="industrylist" :e-industry="info.eIndustry" @change="changeIndustry" />
                    </v-form-item>
                    <v-form-item label="联系电话" name="ePhone" desc="修改此信息直接生效，无需审核" :rules="rules.phone">
                        <telSelect ref="telSelect" :phone="info.ePhone" :sel-type="info.phoneType" @change="changePhone" />
                    </v-form-item>
                    <v-form-item label="企业地址" required="请选择企业地址" name="eAddress">
                        <selectProvince :e-address="info.eAddress" @change="changeProvince" />
                    </v-form-item>
                    <v-form-item v-if="info.phoneType === 2" label="验证码" name="smscode" :rules="rules.smscode" :required="needSms ? '请输入验证码' : ''">
                        <sms-code ref="smscode" :disabled="!canSendSms" @getSmsCode="getSmsCode" @change="(val) => smscode = val" />
                    </v-form-item>
                    <v-form-item label="企业签名" name="signature">
                        <v-input v-model.trim="info.signature" placeholder="请输入" :limit="50" :length-calculator="externalNameCalc" />
                    </v-form-item>
                    <v-form-item label="详细地址" required="请输入企业详细地址" name="eAddressDetail">
                        <v-input v-model.trim="info.eAddressDetail" placeholder="请输入" limit="24" :length-calculator="externalNameCalc" />
                        <div class="tips">
                            直接填写街道、门牌号（如：迎新大道100号），修改此信息直接生效，无需审核
                        </div>
                    </v-form-item>
                    <v-form-item label="电子邮箱" name="eEmail" desc="修改此信息直接生效，无需审核" :rules="rules.email">
                        <v-input v-model.trim="info.eEmail" placeholder="请输入" :limit="48" />
                    </v-form-item>
                </div>
                <v-form-item v-if="corpAdmin.need_attachment" label="附件" name="eAttachment" class="eAttachment">
                        <addAttachment :e-attachment="info.eAttachment" @changeAttachment="changeAttachment" />
                    </v-form-item>
            </v-form>
            <div class="corpinfo-edit-footer">
                <div
                    class="btn-item"
                >
                    <v-footer-actionbar
                        :divider="false"
                        class="corpinfo-edit-footer-actionbar"
                        :layout="{
                            primary: {
                                type: 'submit',
                                text: '确定',
                                disabled: info.status == 1 && corpAdmin.need_verify
                            },
                            cancel: {
                                text: '取消',
                            }
                        }"
                        size="large"
                        @confirm="confirm"
                        @cancel="goBack"
                    />
                </div>
            </div>
        </div>
        <v-dialog v-model="verifyDlg" kind="modal" confirm-text="更新并提交审核">
            <span>需1~2个工作日审核方可生效</span>
        </v-dialog>
    </div>
</template>
<script>
import selectIndustry from '../components/select-industry.vue';
import selectProvince from '../components/select-province.vue';
import changeAvatarDialog from '../components/change-avatar-dialog.vue';
import addAttachment from '../components/add-attachment.vue';
import telSelect from '../components/tel-select.vue';
import { logo } from '../utils/defaultConfig';
import reviewFailed from '../components/review-failed.vue';
import smsCode from '../components/sms-code.vue';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { checkIndustry, verifyCode } from '../utils/cgi';
const regPhone = /^1(3\d|4[5-8]|5[0-35-9]|6[567]|7[01345-8]|8\d|9[025-9])\d{8}$/;
const regTel = /^[\d|\-|\+| |#]+$/;
export default {
    components: {
        selectIndustry,
        selectProvince,
        changeAvatarDialog,
        addAttachment,
        telSelect,
        reviewFailed,
        smsCode,
    },
    props: {
        industrylist: {
            type: Array,
            default: () => [],
        },
        editInfo: {
            type: Object,
            default: () => {},
        },
        corpAdmin: {
            type: Object,
            default: () => ({
                need_verify: true,
                need_attachment: true,
                need_sms_code: true,
                need_related_corp: true,
            }),
        },
    },
    data() {
        return {
            logo,
            preInfo: {},
            info: {
                eFullName: '',
                eName: '',
                eDesc: '',
                signature: '',
                eIndustry: {
                    area: -3,
                    areaDetail: -2,
                },
                eLogo: '',
                eAddress: {
                    province: '',
                    city: '',
                },
                eAddressDetail: '',
                ePhone: '',
                eEmail: '',
                eHome: '',
                status: '',
                lastVTime: '',
                phoneType: 2,
                phoneIsVerified: 0,
                error: [],
                eAttachment: [],
            },
            verifyDlg: false,
            rules: {
                email: [
                    {
                        message: '电子邮箱格式有误',
                        validate: (val) => {
                            const reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
                            if (!reg.test(val) && val.length) {
                                return false;
                            }
                            return true;
                        },
                        trigger: 'blur',
                    },
                ],
                eHome: [
                    {
                        message: '请填写完整主页地址，一般以http://或https://等网络协议开头',
                        validate: (val) => {
                            if (!val.match(/^(https?|ftp):\/\//) && val.length) {
                                return false;
                            }
                            return true;
                        },
                        trigger: 'submit',
                    },
                ],
                smscode: [
                    {
                        message: '验证码必须为6位',
                        validate: (val) => {
                            if (val.length && val.length !== 6 && this.needSms) {
                                return false;
                            }
                            return true;
                        },
                        trigger: 'submit',
                    },
                ],
                phone: [
                    {
                        message: '手机号格式错误',
                        validate: () => {
                            if (this.info.ePhone && !regPhone.test(this.info.ePhone) && this.info.phoneType === 2) {
                                return false;
                            }
                            return true;
                        },
                        trigger: 'submit',
                    },
                    {
                        message: '座机号码格式错误',
                        validate: () => {
                            if (this.info.ePhone && !regTel.test(this.info.ePhone) && this.info.phoneType === 1) {
                                return false;
                            }
                            return true;
                        },
                        trigger: 'submit',
                    },
                ],
                industry: [{
                    message: '请选择行业',
                    validate: (val) => {
                        if (val && val.length && val[0] > 0 && val[1] > 0) return true;
                        return false;
                    },
                    trigger: 'submit',
                }],
            },
        };
    },
    computed: {
        needSms() {
            // 更改手机号需要验证码
            const { need_sms_code } = this.corpAdmin;
            const res = this.info.phoneType === 1 || this.info.ePhone === this.preInfo.ePhone || this.info.ePhone.length === 0 || !need_sms_code;
            return !res;
        },
        canSendSms() {
            return regPhone.test(this.info.ePhone);
        },
    },
    created() {
        this.preInfo = cloneDeep(this.editInfo);
        this.info = this.editInfo;
    },
    methods: {
        getSmsCode() {
            this.$refs.smscode?.getSmsCode({
                phone: this.info.ePhone,
            });
        },
        resetInfo() {
            this.$ajax.gatewayPost('/v1/basic/corp/corp/renewCorpInfo').then((res) => {
                this.$emit('goBack');
            })
            .catch((err) => {
                this.$message.error(err.message || '网络故障，请稍后再试');
            });
        },
        externalNameCalc(str) {
            if (str == null) return 0;
            if (typeof str != 'string') {
                str += '';
            }
            return Math.round(str.replace(/[^\x00-\xff]/g, '01').length / 2);
        },
        changePhone(val) {
            this.$set(this.info, 'phoneType', val.phoneType);
            this.info.ePhone = val.phone;
        },
        changeProvince(val) {
            this.info.eAddress = val;
        },
        changeIndustry(val) {
            this.info.eIndustry = val;
        },
        avatarChange(url) {
            this.$set(this.info, 'eLogo', url);
        },
        changeAttachment(data) {
            this.info.eAttachment = data;
        },
        customFn(res) {
            if (res.code !== 0) {
                this.$message.error(res.message || res.msg || '网络故障，请稍后再试');
            }
        },
        goBack() {
            const that = this;
            this.$confirm({
                title: '返回企业资料？',
                content: '当前编辑的信息将不会保存。',
                confirmText: '返回',
                confirm() {
                    that.$emit('goBack');
                },
            });
        },
        confirm(e) {
            e.preventDefault();
            this.$refs.form.submit();
        },
        submit(e) {
            e.preventDefault();
            this.formSubmit();
        },
        async formSubmit() {
            // 校验行业
            if (!await checkIndustry({
                category: this.info.eIndustry.area,
                sub_category: this.info.eIndustry.areaDetail,
            })) return;
            // 校验短信验证码
            if (this.needSms) {
                const res =  await verifyCode({
                    phone: this.info.ePhone,
                    code: this.smscode,
                    related_id: 0,
                });
                if (!res) return;
            }
            const params = {
                ...this.info,
                eCorpQualification: this.info.eAttachment,
            };
            if (this.need_verify(params)) {
                const that = this;
                this.$confirm({
                    content: '需1~2个工作日审核方可生效',
                    confirmText: '更新并提交审核',
                    confirm() {
                        that.update(params);
                    },
                });
            } else {
                this.update(params);
            }
        },
        update(params) {
            this.$ajax.post('/mng/account/corpInfo/create', params).then((res) => {
                this.$message.success('修改成功');
                this.$emit('goBack');
            });
        },
        need_verify(params) {
            const keys = ['eName', 'eDesc', 'eLogo', 'eIndustry', 'eHome', 'eAttachment'];
            const preVerifyInfo = {};
            const info = {};
            keys.forEach((key) => {
                preVerifyInfo[key] = this.preInfo[key];
                info[key] = params[key];
            });
            if (isEqual(preVerifyInfo, info)) return false;
            return true;
        },
    },
};
</script>
<style lang="less" scoped>
.verify-status {
    margin-bottom: 20px;
}
.edit-disabled {
    opacity: 0.4;
    cursor: default;
    -ms-pointer-events: none;
    pointer-events: none;
}
.tips {
    color: var(--color-text-caption);
    font-size: 12px;
}
.form-item-list {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 32px));
    grid-gap: 0 64px;
}

/deep/ .v-textarea, .v-input {
    width: 100%;
}
/deep/ .text-area {
    max-height: 110px !important;
    .v-textarea__txt {
        display: inline-flex;
        max-height: 80px;
        height: inherit;
        overflow-y: auto;
    }
}
.upload {
    width: 100%;
}
.avatar {
    display: inline-flex;
    height: 48px;
    align-items: center;
    &-view {
        width: 48px;
        height: 48px;
        border-radius: 100%;
        display: inline-block;
        margin-right: 9px;
    }
}
.form-avatar {
    width: calc(50% + 32px);
}
/deep/ .v-description-item--text-content {
    flex: 0 0 auto;
}
.corpinfo-edit-footer {
    height: 73px;
    /deep/ .v-description-item--text-content {
        width: 0px;
    }
    &-actionbar {
        height: 73px;
        width: -webkit-fill-available;
        position: fixed;
        bottom: 0;
        z-index: 1;
        background-color: #fff;
    }
}
.eAttachment {
    width: calc(50% + 32px);
    margin-bottom: 73px;
}
</style>
